import React, { useState } from "react";
import axios from "axios";
import Modal from "react-modal";
import ForgotPasswordForm from "../Password/ForgotPasswordForm";

const SignInForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [ModalForgotPasswordOpen, setModalForgotPasswordOpen] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    const emailError = document.querySelector(".email.error");
    const passwordError = document.querySelector(".password.error");

    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/api/user/login`,
      withCredentials: true,
      data: {
        email: email,
        password: password,
      },
    })
      .then((res) => {
        if (res.data.errors) {
          emailError.innerHTML = res.data.errors.email;
          passwordError.innerHTML = res.data.errors.password;
        } else {
          window.location = "/Profil";
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <form action="" onSubmit={handleLogin} id="signIpForm">
      <label htmlFor="email">Email</label>
      <br />
      <input
        type="text"
        name="email"
        id="email"
        onChange={(e) => setEmail(e.target.value)}
        value={email}
      />
      <br />
      <div className="email error"></div>
      <label htmlFor="password">Mot de passe</label>
      <br />
      <input
        type="password"
        name="password"
        id="password"
        onChange={(e) => setPassword(e.target.value)}
        value={password}
      />
      <br />
      <div className="password error"></div>
      <p
        onClick={() => setModalForgotPasswordOpen(true)}
        style={{ cursor: "pointer" }}
      >
        Mot de passe oublié ?
      </p>
      <input
        id="submit"
        className="button"
        type="submit"
        value="Se connecter"
      />
      <Modal
        isOpen={ModalForgotPasswordOpen}
        onRequestClose={() => setModalForgotPasswordOpen(false)}
        style={customStyles}
      >
        <button onClick={() => setModalForgotPasswordOpen(false)}>
          Fermer
        </button>
        <ForgotPasswordForm />
      </Modal>
    </form>
  );
};

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "2rem",
    borderRadius: "10px",
  },
};

export default SignInForm;
